module.exports = __webpack_public_path__ + "img/icon-twitter.67ea325c.svg";